<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				ref='table'
				border
				stripe
				:height="tableHeight"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				@sort-change='sortChangeHandle'
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="staffname"
					label="员工姓名"
					fixed="left"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customername"
					label="客户"
					fixed="left"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.customername}}</div>
						<div>编号：{{scope.row.customercode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordernumber"
					label="订单编号"
					fixed="left"
					align="center">
					<template slot-scope="scope">
						<!-- <div :title="scope.row.productname" class="product-name"><div v-if="scope.row.giftflag" class="giftLogo">赠</div><div class="p-name">{{scope.row.productname}}</div></div> -->
						<div @click="goOrderDetail(scope.row)" class="under-num">{{scope.row.ordernumber}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="realpaymoney"
					sortable="custom"
					label="实付金额"
					align="center">
					<template slot="header">
						实付金额
						<el-tooltip class="item" effect="dark" content="实付金额=订单付款金额-运费金额-退款金额" placement="top">
							<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
						</el-tooltip>
					</template>
					<template slot-scope="scope">
						<div>￥{{scope.row.realpaymoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionType"
					label="返佣方式"
					align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.planway === 1 ? '按订单' : '按商品' }}：{{scope.row.commissionType === 1 ? `百分比（${$fxUtils.toFixedSHW(scope.row.commissionvalue, 2)}%）` : `固定金额（￥${$fxUtils.toFixedSHW(scope.row.commissionvalue, 2)}）`}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="returnmoney"
					sortable="custom"
					label="返佣金额"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.returnmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordercreatedate"
					label="下单时间"
					align="center"
					width="104">
				</el-table-column>
				<el-table-column
					prop="censusdate"
					label="统计时间"
					align="center"
					width="104">
					<template slot-scope="scope">
						<div>{{scope.row.censusdate ? scope.row.censusdate : '——'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashoutdate"
					label="申请提现时间"
					align="center"
					width="104">
					<template slot-scope="scope">
						<div>{{scope.row.cashoutdate ? scope.row.cashoutdate : '——'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashOutStatus"
					label="提现状态"
					align="center"
					width="104"
				>
					<template slot-scope="scope">
						<div v-if="scope.row.cashOutStatus === 0">待申请</div>
						<div v-if="scope.row.cashOutStatus === 1">待审核</div>
						<div v-if="scope.row.cashOutStatus === 2">已审核</div>
					</template>
				</el-table-column>
				<el-table-column label="提现达成条件" width="250" align="center">
					<template slot-scope="scope">
						<div style="display: flex;flex-wrap: wrap;">
							<div :class="scope.row.orderStatus ? 'green' : 'gray'">订单已完成</div>
							<div :class="scope.row.refundStatus ? 'green' : 'gray'">退单已完成</div>
							<div :class="scope.row.orderAllPay ? 'green' : 'gray'">无未付款金额</div>
							<div :class="scope.row.canRefund ? 'green' : 'gray'">不可申请退货</div>
							<div :class="scope.row.canRealReceiveAmount ? 'green' : 'gray'">不可修改实收数</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="display: flex;align-items: center;justify-content: center;">
			<div style="width: 430px;padding-right: 50px;display: flex;align-items: center;justify-content: space-between;">
				<div>统计范围：当前页</div>
				<div>实付金额：￥{{realpaymoneySum ? realpaymoneySum : '- - . - -'}} <span class="under-num" style="display:inline-block;" @click="getRealpaymoneySum">计算</span></div>
				<div>返佣金额：￥{{returnmoneySum ? returnmoneySum : '- - . - -'}} <span class="under-num" style="display:inline-block;" @click="getReturnmoneySum">计算</span></div>
			</div>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="page"
				:page-sizes="[20,40, 60, 100]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalCount">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			// pagination: {
			// 	page: this.page,
			// 	size: this.size
			// },
			realpaymoneySum: 0,
			returnmoneySum: 0,
			// commissionmoneySum: 0,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			})
		}
	},
	watch: {
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(val, this.$refs.table)
				})
			},
			immediate: true
		}
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
		// this.getSum()
	},
	methods: {
		clear () {
			this.tableSelectUtils.clear()
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id,
				realpaymoney: row.realpaymoney,
				commissionmoney: row.commissionmoney
			}
		},
		// 跳订单
		goOrderDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderid
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		// 跳退单
		goRefundOrderDetail (row) {
			let a = JSON.stringify(row)
			window.sessionStorage.setItem('refundOrderParams', a)
			this.$fxGoBlank('/blankRefundDetail', this.$router)
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			// this.getSum()
			let list = this.ids
			let selectIds = list.map(item => {
				return item.id
			})
			this.$emit('selectIds', selectIds)
		},
		sortChangeHandle (data) {
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		handleSizeChange (value) {
			this.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.page = value
			this.$emit('handlePage', value)
		},
		getRealpaymoneySum () {
			let values = this.tableData.map(item => {
				return Number(item.realpaymoney)
			})
			let sumValue = values.reduce((pre, cur) => {
				return pre + cur
			}, 0)
			this.realpaymoneySum = this.$fxUtils.toFixedSHW(sumValue, 2)
		},
		getReturnmoneySum () {
			let values = this.tableData.map(item => {
				return Number(item.returnmoney)
			})
			let sumValue = values.reduce((pre, cur) => {
				return pre + cur
			}, 0)
			this.returnmoneySum = this.$fxUtils.toFixedSHW(sumValue, 2)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.product-name {
			display: flex;
			justify-content: center;
			align-items: center;
			.giftLogo{
				margin-right :5px;
				font-size :10px;
				width: 24px;
				height: 18px;
				line-height: 18px;
				color: var(--fx-primary-color);
				border: 1px solid var(--fx-primary-color);
				border-radius :5px;
				flex-shrink: 0
			}
			.p-name {
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
		.gray {
			color:#999;
			background: #eee;
			border-radius: 5px;
			border: 1px solid #999;
			margin: 6px;
			padding: 2px 5px;
		}
		.green {
			color: #60c769;
			background: #eefce9;
			border-radius: 5px;
			border: 1px solid #60c769;
			margin: 6px;
			padding: 2px 5px;
		}
		.under-num {
			cursor :pointer;
			color: var(--fx-primary-color);
			text-decoration: underline
			display: flex;
			align-items: center;
		}
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.under-num {
		cursor :pointer;
		color: var(--fx-primary-color);
		text-decoration: underline
		display: flex;
		align-items: center;
	}
	.under-num1 {
		color: var(--fx-primary-color);
		display: flex;
		align-items: center;
		span {
			cursor :pointer;
			text-decoration: underline
		}
		.return-icon {
			margin-left :5px;
			font-size :10px;
			width: 20px;
			height: 18px;
			line-height: 16px;
			color :#EC4141;
			border :1px solid #EC4141;
			border-radius :5px;
			flex-shrink: 0
		}
	}
}
</style>
s
